import marketplacePropertiesService from '../MarketplacePropertiesService';
import sessionReader from '../../store/readHelpers/SessionReader';

function isFullyAutomatedIdBypassEnabled() {
    return marketplacePropertiesService.isAutomaticIdBypassEnabled()
        && sessionReader.isAutomaticIdVerificationEnabled()
        && !sessionReader.isManualIdVerificationEnabled();
}

const similarityChecker = {
    isFullyAutomatedIdBypassEnabled,
    shouldPassSimilarityCheck(response) {
        if (similarityChecker.isFullyAutomatedIdBypassEnabled()) {
            return true;
        }
        return !!(response?.Approvable);
    },
};

export default similarityChecker;
